import dayJs from "dayjs";
import { events } from "../../../scripts/constants";
import { EventEmitter, showElement, trackCheckoutEvent } from "../../../utils";
import { hideBasketAlertBox, showBasketAlertBox } from "../alerts";
import { hideBasketNotificationBar } from "../alerts/hideBasketNotificationBar";
import { reportError } from "../basket-v2/errorReporting";
import { constants } from "../common";
import setBasketRemainingTime from "./setBasketRemainingTime";

let basketExpiryTimer: number | undefined = null;
let raisedBasketExpiryEvent: boolean = false;
const currentURL: string = window.location.href;

export function setBasketExpiryTimer(expiryDate: dayJs.Dayjs, checkoutUrl?: string, delay: number = 300000) {
  // @ts-ignore
  window.basketExpiryTime = expiryDate;
  raisedBasketExpiryEvent = false;

  if (expiryDate.isValid()) {
    try {
      window.localStorage.setItem(constants.defaults.basketExpiryTimeLocalStorageKey, expiryDate.toISOString());
    } catch {
      console.warn("Failed to store basket expiry time in localStorage.");
    }
  }

  if (!document.querySelector(constants.selectors.basketAlert)) {
    return;
  }

  const basketExpiryBar = document.querySelector(constants.selectors.basketExpiryNotice);

  if (!!basketExpiryTimer) {
    clearInterval(basketExpiryTimer);
  }

  setBasketRemainingTime(expiryDate);

  basketExpiryTimer = self.setInterval(function () {
    const now = dayJs();
    var diffMs = expiryDate.diff(now, "millisecond");

    if (diffMs <= 0) {
      clearInterval(basketExpiryTimer);
      basketExpiryTimer = null;

      hideBasketAlertBox();
      hideBasketNotificationBar();

      try {
        window.localStorage.removeItem(constants.defaults.basketAlertLocalStorageKey);
      } catch {
        console.warn("Failed to remove basket alert from localStorage.");
      }

      reportError("ar", "Your basket has expired.");

      trackCheckoutEvent({
        message_name: "basket_timeout_occurred",
        message_type: "warning",
        checkout_step: "basket",
      });

      // redirect in checkout
      if (currentURL.includes("checkout")) {
        window.location.href = checkoutUrl;
      }

      // redirect in basket, unless already on the expired URL (server can still return a past-expiry basket)
      const basketUrl = new URL(window.location.href);
      if (currentURL.includes("basket") && basketUrl.searchParams.get("status") !== "expired") {
        basketUrl.searchParams.set("status", "expired");
        window.location.href = basketUrl.toString();
      }

      return;
    } else if (diffMs <= delay) {
      showBasketAlertBox({
        message: "<strong>WARNING</strong>",
        delay: "none",
        style: "time-warning",
        checkoutUrl,
        onClosed: () => {
          try {
            window.localStorage.setItem(constants.defaults.basketAlertLocalStorageKey, "true");
          } catch {
            console.warn("Failed to store basket alert in localStorage.");
          }

          if (!basketExpiryBar) {
            clearInterval(basketExpiryTimer);
            basketExpiryTimer = null;
          } else {
            showElement(basketExpiryBar);
          }

          const timeWarning = document.querySelector(constants.selectors.timeWarning);
          if (timeWarning) {
            timeWarning.remove();
          }
        },
      });

      if (!raisedBasketExpiryEvent) {
        trackCheckoutEvent({
          message_name: "basket_timeout_popup",
          message_type: "warning",
          checkout_step: "basket",
        });
        raisedBasketExpiryEvent = true;
      }
    }

    setBasketRemainingTime(expiryDate);
  }, 1000);
}

EventEmitter.on(
  events.SET_BASKET_EXPIRY_TIMER,
  ({ expiryDate, checkoutUrl, delay }: { expiryDate: dayJs.Dayjs; checkoutUrl?: string; delay?: number }) => {
    setBasketExpiryTimer(expiryDate, checkoutUrl, delay);
  }
);
